<template>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <!-- <el-tab-pane label="供应商履约">供应商履约</el-tab-pane>-->
        <el-tab-pane label="专业类别冻结" name="freeze">
            <div class="button-class">
                <el-button :disabled="multipleSelection.length == 0" type="warning" @click="openTheInvitationToInitiateBidRecovery">发起投标资格恢复请求函</el-button>
            </div>
            <el-table
                :data="professionalVos"
                border
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column align="center"
                                 type="selection"
                                 width="55">
                </el-table-column>
                <!--<el-table-column align="center"
                     type="index"
                     label="序号"
                     >
                 </el-table-column>-->
                <el-table-column align="center"
                                 prop="person"
                                 label="专业负责人"
                >
                </el-table-column>
                <el-table-column align="center"
                                 prop="productType"
                                 label="产品及服务"
                >
                </el-table-column>
                <el-table-column align="center"
                                 prop="provinceCity"
                                 label="服务区域"
                >
                </el-table-column>
                <el-table-column align="center"
                                 label="状态"
                >
                    <template slot-scope="scope">
                        {{ '冻结' }}
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog v-loading="loading"
                title="投标资格恢复请求函"
                :visible.sync="dialogVisible"
                width="80%"
                :before-close="handleClose">
                <el-table
                    :data="multipleSelection"
                    border>
                    <el-table-column align="center"
                                     type="index"
                                     label="序号" width="80"
                    >
                    </el-table-column>
                    <el-table-column align="center"
                                     prop="person"
                                     label="专业负责人"
                    >
                    </el-table-column>
                    <el-table-column align="center"
                                     prop="productType"
                                     label="产品及服务"
                    >
                    </el-table-column>
                    <el-table-column align="center"
                                     prop="provinceCity"
                                     label="服务区域"
                    >
                    </el-table-column>
                    <el-table-column align="center"
                                     label="状态"
                    >
                        <template slot-scope="scope">
                            {{ '冻结' }}
                        </template>
                    </el-table-column>
                </el-table>

                <h3><span style="color: red;">*</span>请求说明：</h3>
                <el-input v-model="requestDescription" placeholder="请输入内容"></el-input>

                <h3>附件：</h3>
                <el-upload
                    class="upload-demo"
                    :action="uploadApi"
                    :on-success="handlePreviewSuccess"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>

                <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogVisible = false">取 消</el-button>
                     <el-button type="primary" @click="formSubmission">确 定</el-button>
                </span>
            </el-dialog>
        </el-tab-pane>

        <el-tab-pane label="发起记录" name="history">
            <el-table
                :data="historyRecords"
                border
                style="width: 100%">
                <el-table-column align="center"
                     type="index"
                     label="序号"
                     >
                </el-table-column>
                <el-table-column align="center"
                                 prop="approveRemark"
                                 show-overflow-tooltip
                                 label="请求说明"
                >
                </el-table-column>
                <el-table-column align="center"
                                 prop="crateDate"
                                 label="发起时间"
                >
                </el-table-column>
                <el-table-column align="center"
                                 prop="statusName"
                                 label="状态"
                >
                </el-table-column>
                <el-table-column align="center"
                                 label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="gotoDetail(scope.row.id)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="10"
                :current-page="pageNum"
                :total="total"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
            >
            </el-pagination>


            <el-dialog
                title="详情"
                :visible.sync="detailSHow"
                width="65%">
                <div v-if="!!detailInfo" class="detail-box">
                    <label class="fade-title">请求信息
                        <span style="float: right;">{{ detailInfo.approvalRecord.createDate }}</span>
                    </label>
                    <el-row>
                        <el-col :span="3" class="text-right">请求说明：</el-col>
                        <el-col :span="18">{{ detailInfo.statusInfo.confirmExplain }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="3" class="text-right">请求附件：</el-col>
                        <el-col :span="18">
                            <div v-if="detailInfo.fileList.length==0" class="no-data-tip"/>
                            <div v-else>
                                <span v-for="li in detailInfo.fileList" :key="li.id">
                                    <a :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a>
                                </span>
                            </div>
                        </el-col>
                    </el-row>
                    <hr class="dialog-hr"/>
                    <label class="fade-title">审批信息</label>

                    <el-table
                        :data="oaList"
                        border
                        style="width: 100%">
                        <el-table-column align="center"
                             type="index"
                             label="序号" width="80"
                             >
                        </el-table-column>
                        <el-table-column align="center"
                                         prop="statusName"
                                         show-overflow-tooltip
                                         label="审批结果"
                        ></el-table-column>
                        <el-table-column align="center"
                                         prop="approveRemark"
                                         show-overflow-tooltip
                                         label="审批意见"
                        ></el-table-column>
                        <el-table-column align="center"
                                         prop="approveDate"
                                         show-overflow-tooltip
                                         label="审批时间"
                        ></el-table-column>
                    </el-table>
                </div>
                <span slot="footer" class="dialog-footer">
                      <el-button @click="detailSHow = false">关闭</el-button>
                </span>
            </el-dialog>
        </el-tab-pane>
    </el-tabs>


</template>

<script>
    import util from '@/util'

    export default {
        name: 'PerformRequestLetter',
        data () {
            return {
                baseUrl: util.baseUrl,
                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,
                professionalVos: [],
                dialogVisible: false,

                multipleSelection: [],
                requestDescription: '',
                fileList: [],
                loading: false,
                activeName: 'freeze',
                historyRecords: [],
                pageNum: 1,
                total: 0,
                detailSHow: false,
                detailInfo: null,
                oaList: [],
            }
        },
        methods: {
            openTheInvitationToInitiateBidRecovery () {
                if (!this.multipleSelection || this.multipleSelection.length == 0) {
                    this.$alert('请选择需要解冻的专业类别！')
                    return false
                }
                this.requestDescription = ''
                this.fileList = []
                this.dialogVisible = true
            },
            __getBaseFiles__ (f) {
                // let f = file.response.basefiles[0]
                let file = {}
                file.fileOldName = f.fileoldname
                file.fileName = f.filename
                file.filePath = f.filepath
                file.fileSize = f.filesize
                file.fileType = f.filetype
                file.sort = f.sort
                file.name = f.fileoldname
                return file
            },
            formSubmission () {
                if (!this.requestDescription) {
                    this.$message({type: 'error', message: '必须填写请求说明'})
                    return false
                }

                let formData = {
                    type: 20,
                    disPlayIds: [],
                    explain: '',
                    fileList: []
                }
                for (let multipleSele of this.multipleSelection) {
                    formData.disPlayIds.push(multipleSele.spsDisplayId)
                }
                formData.explain = this.requestDescription
                //处理文件
                for (let file of this.fileList) {
                    formData.fileList.push(this.__getBaseFiles__(file))
                }
                this.loading = true
                this.$http.post(`rest/api/SingleContractPerformance/startRecover`, formData).then((res) => {
                    if (res.data.result) {
                        this.$message({type: 'success', message: '请求成功'})
                        this.multipleSelection = [],
                        this.dialogVisible = false
                        this.getData()
                    } else {
                        this.$message({type: 'error', message: res.data.message})
                    }
                    this.loading = false
                })
            },
            handleClose (done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done()
                    })
                    .catch(_ => {
                    })
            },
            getData () {
                this.$http.get(`rest/api/SingleContractPerformance/professionalCategoryFreeze`).then((res) => {
                    if (res.data.result) {
                        this.professionalVos = res.data.value
                    } else {
                        this.$message({type: 'error', message: res.data.message})
                    }
                })
            },
            handleSelectionChange (val) {
                this.multipleSelection = val
            },

            handleRemove (file, fileList) {
                console.log(file, fileList)
            },
            handlePreview (file) {
                console.log(file)
            },
            handleExceed (files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
            },
            beforeRemove (file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`)
            },
            handlePreviewSuccess (file) {
                for (let fil of file.basefiles) {
                    this.fileList.push(fil)
                }
            },
            handleClick () {
                switch (this.activeName) {
                    case 'freeze': this.getData(); break;
                    case 'history': this.getHistory(); break;
                }
            },
            getHistory () {
                this.$http.post('rest/api/SingleContractPerformance/getHistory', {pageNum: this.pageNum}).then((res) => {
                    if (res.data.result) {
                        this.historyRecords = res.data.value.list || []
                        this.total = res.data.value.count
                    } else {
                        this.$message({type: 'error', message: res.data.message})
                    }
                })
            },
            handleCurrentChange (page) {
                this.pageNum = page
                this.getHistory()
            },
            gotoDetail (id) {
                this.detailInfo = null
                this.oaList = []
                this.$http.get(`rest/api/SingleContractPerformance/getRecoverDetail/${id}`).then((res) => {
                    if (res.data.result) {
                        this.detailInfo = res.data.value
                        this.detailSHow = true
                        this.oaList = [
                            {
                                statusName: this.detailInfo.approvalRecord.statusName || '未审批',
                                approveRemark: this.detailInfo.approvalRecord.approveRemark,
                                approveDate: this.detailInfo.approvalRecord.approveDate
                            }
                        ]
                    } else {
                        this.$message({type: 'error', message: res.data.message})
                    }
                })
            },
        },
        created () {
            this.getData()
        },
    }


</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';
    .button-class {
        margin-bottom: 10px;
    }
    .invite-form {
        background: #F5F6F5;
        padding: 25px 10px 10px 10px;
        margin: 0 0 25px 0;
    }

    .echart-box {
        height: 330px;
        width: 500px;
    }

    .fade-title {
        display: inline-block;
        width: 100%;
        margin-bottom: 20px;
        color: var(--cTxt2);
        font-size: 15px;
        font-weight: bold;
        line-height: 28px;
    }

    .appeal-dialog .el-dialog__header {
        background-color: #F4F5FA;
    }

    .dialog-hr {
        margin: 15px 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/pfeva/PerformRequestLetter.vue